'use client';

import dynamic from 'next/dynamic';
import { useTranslations } from 'next-intl';
import {
  HeroSection,
  PincodeCtaBannerSection,
  GetDirectionsSection,
} from 'components/performance-lab';
import { DIAGNOSTICS_STATEMENT_BG_FALLBACK } from 'components/performance-lab/diagnosticsStatementSectionData';
import { DATA_PARALLAX_BG } from 'components/performance-lab/plLandingAssets';

const TextRevealSection = dynamic(
  () =>
    import('components/performance-lab/TextRevealSection').then(
      (mod) => mod.TextRevealSection,
    ),
  { ssr: false },
);
const SignalsOverviewSection = dynamic(
  () =>
    import('components/performance-lab/SignalsOverviewSection').then(
      (mod) => mod.SignalsOverviewSection,
    ),
  { ssr: false },
);
const SolutionSection = dynamic(
  () =>
    import('components/performance-lab/SolutionSection').then(
      (mod) => mod.SolutionSection,
    ),
  { ssr: false },
);
const ComparisonSection = dynamic(
  () =>
    import('components/performance-lab/ComparisonSection').then(
      (mod) => mod.ComparisonSection,
    ),
  { ssr: false },
);
const PlansSection = dynamic(
  () =>
    import('components/performance-lab/PlansSection').then(
      (mod) => mod.PlansSection,
    ),
  { ssr: false },
);
const ProcessSection = dynamic(
  () =>
    import('components/performance-lab/ProcessSection').then(
      (mod) => mod.ProcessSection,
    ),
  { ssr: false },
);
const TestimonialsSection = dynamic(
  () =>
    import('components/performance-lab/TestimonialsSection').then(
      (mod) => mod.TestimonialsSection,
    ),
  { ssr: false },
);

const PerformanceLabPage = () => {
  const t = useTranslations('performance-lab');

  return (
    <>
      <HeroSection />
      <TextRevealSection
        ariaLabel={t('textReveal.aria')}
        bodyText={t('textReveal.body')}
        scrollTrackVhMobile={2}
        scrollTrackVhDesktop={3}
        bookTourScrollAnchor
      />
      <SignalsOverviewSection />
      <TextRevealSection
        ariaLabel={t('diagnosticsStatement.aria')}
        imageOnly
        scrollEnterVhMobile={0}
        scrollEnterVhDesktop={0}
        scrollExitVhMobile={0}
        scrollExitVhDesktop={0}
        scrollTrackVhMobile={1}
        scrollTrackVhDesktop={1}
        backgroundColor={DIAGNOSTICS_STATEMENT_BG_FALLBACK}
        backgroundImages={DATA_PARALLAX_BG}
        clipOverflow
        fixedBackgroundScroll
      />
      {/* <ProblemSection /> */}
      <SolutionSection />
      <ComparisonSection />
      <PlansSection />
      <ProcessSection />
      <TestimonialsSection />
      <PincodeCtaBannerSection />
      <GetDirectionsSection />
      {/* <FaqSection /> */}
    </>
  );
};

export default PerformanceLabPage;
